import React, { useState, useEffect } from "react";
import classes from "./ShowContactDetailModal.module.css";
import moment from "moment-timezone";

export default function ShowContactDetailModal({
  message,
  onClose,
  onMarkRead,
}) {
  const [isRead, setIsRead] = useState(message?.is_read || false);

  useEffect(() => {
    setIsRead(message?.is_read || false);
  }, [message]);

  if (!message) return null;

  const handleMarkRead = () => {
    onMarkRead?.();
    setIsRead(true);
  };

  // Convert time to Pakistan Standard Time (UTC+5) and format with AM/PM
  const formattedTime = moment(message.created_at)
    .tz("Asia/Karachi")
    .format("DD MMM YYYY, hh:mm A");

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <header className={classes.header}>
          <div>
            <p className={classes.kicker}>Contact Request</p>
            <h3>
              #{message.id} &middot; {message.name}
            </h3>
            <span
              className={`${classes.readStatus} ${
                isRead ? classes.read : classes.unread
              }`}
            >
              {isRead ? "Read" : "Unread"}
            </span>
          </div>
          <button className={classes.closeBtn} onClick={onClose}>
            ×
          </button>
        </header>

        <div className={classes.content}>
          {/* Contact Info */}
          <div className={classes.section}>
            <h4 className={classes.sectionTitle}>Contact Information</h4>
            <div className={classes.infoGrid}>
              <div className={classes.infoItem}>
                <span className={classes.label}>Name</span>
                <strong>{message.name}</strong>
              </div>
              <div className={classes.infoItem}>
                <span className={classes.label}>Email</span>
                <strong>
                  <a href={`mailto:${message.email}`}>{message.email}</a>
                </strong>
              </div>
              <div className={classes.infoItem}>
                <span className={classes.label}>Phone</span>
                <strong>
                  {message.phone ? (
                    <a href={`tel:${message.phone}`}>{message.phone}</a>
                  ) : (
                    "—"
                  )}
                </strong>
              </div>
              <div className={classes.infoItem}>
                <span className={classes.label}>SKU</span>
                <strong>{message.sku || "—"}</strong>
              </div>
            </div>
          </div>

          {/* Address */}
          {message.address && (
            <div className={classes.section}>
              <h4 className={classes.sectionTitle}>Address</h4>
              <p className={classes.addressText}>{message.address}</p>
            </div>
          )}

          {/* Message */}
          <div className={classes.section}>
            <h4 className={classes.sectionTitle}>Message</h4>
            <div className={classes.messageBox}>
              <p>{message.message}</p>
            </div>
          </div>

          {/* Meta Row */}
          <div className={classes.metaRow}>
            <span className={classes.metaLabel}>Received</span>
            <strong className={classes.metaValue}>{formattedTime}</strong>
          </div>

          {!isRead && (
            <button className={classes.markReadBtn} onClick={handleMarkRead}>
              Mark as Read
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
